import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { catchError, Observable, throwError } from 'rxjs';
import { ApiError } from './models/ApiError.interface';
import { TelemetryService } from '../../shared/services/telemetry.service';
import { environment } from '../../../environments/environment';

@Injectable()
export class ApiErrorInterceptor implements HttpInterceptor {
  constructor(
    private snackBar: MatSnackBar,
    private telemetryService: TelemetryService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (this.shouldTrackCriticalApiError(req, error)) {
          this.telemetryService.trackException(error, {
            source: 'ApiErrorInterceptor',
            method: req.method,
            status: String(error.status),
            url: req.urlWithParams || req.url,
          });
        }

        if (error.status === 404) {
          return throwError(() => error);
        }

        const apiError = error.error as ApiError | undefined;
        const code = (apiError as any)?.code ?? (apiError as any)?.Code;
        const message = (apiError as any)?.message ?? (apiError as any)?.Message;

        if (code) {
          switch (code) {
            case 'Unauthorized':
            case 'ApimUnauthorized':
              this.snackBar.open('Du har ikke tilgang eller er logget ut.', 'Lukk', { duration: 5000 });
              break;
            case 'ApimTimeout':
            case 'ApimError':
              this.snackBar.open('Teknisk feil ved henting av data. Prøv igjen senere.', 'Lukk', { duration: 5000 });
              break;
            case 'ValidationError':
              this.snackBar.open(message || 'Ugyldig data i forespørselen.', 'Lukk', { duration: 5000 });
              break;
          }
        } else if (error.status >= 500) {
          this.snackBar.open('Teknisk feil. Prøv igjen senere.', 'Lukk', { duration: 5000 });
        }

        return throwError(() => error);
      })
    );
  }

  private shouldTrackCriticalApiError(req: HttpRequest<any>, error: HttpErrorResponse): boolean {
    if (error.status >= 500) {
      return true;
    }

    if (error.status !== 0) {
      return false;
    }

    const url = req.urlWithParams || req.url;
    const isEmployerApiRequest =
      url.startsWith('/api/') ||
      url.startsWith('/api') ||
      url.startsWith(`${environment.apis.employerApi}/`);

    return isEmployerApiRequest;
  }
}

